module.exports = __webpack_public_path__ + "Pixel_2.svg?a2501c4440741b40bbc35e02c11c9f46";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Pixel_2.svg
// module id = 207
// module chunks = 0